var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35294 16V18C9.35294 18.5304 9.57605 19.0391 9.97319 19.4142C10.3703 19.7893 10.909 20 11.4706 20H18.8824C19.444 20 19.9826 19.7893 20.3798 19.4142C20.7769 19.0391 21 18.5304 21 18L21 6C21 5.46957 20.7769 4.96086 20.3798 4.58579C19.9826 4.21071 19.444 4 18.8824 4L11.4706 4C10.909 4 10.3703 4.21071 9.97319 4.58579C9.57605 4.96086 9.35294 5.46957 9.35294 6V8M15.7059 12L3 12M3 12L6.17647 15M3 12L6.17647 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.4b757a90d0e8cb5823a2078c2203c5d3.svg";
export { ForwardRef as ReactComponent };